<template>
  <div class="sc-message-feedback" :class="{ 'sc-message-feedback--readonly': !interactive }">
    <button
      type="button"
      class="sc-message-feedback__button"
      :class="{ 'sc-message-feedback__button--yes': selected === 'yes' }"
      :aria-pressed="selected === 'yes'"
      :disabled="!interactive"
      aria-label="Helpful"
      @click="onSelect('yes')"
    >
      <icon-thumbs-up
        :solid="selected === 'yes'"
        :color="selected === 'yes' ? '#26CC3F' : '#B6C4D8'"
      />
    </button>
    <button
      type="button"
      class="sc-message-feedback__button"
      :class="{ 'sc-message-feedback__button--no': selected === 'no' }"
      :aria-pressed="selected === 'no'"
      :disabled="!interactive"
      aria-label="Not helpful"
      @click="onSelect('no')"
    >
      <icon-thumbs-down
        :solid="selected === 'no'"
        :color="selected === 'no' ? '#FF5F56' : '#B6C4D8'"
      />
    </button>
  </div>
</template>

<script>
import IconThumbsUp from './icons/icons/IconThumbsUp.vue'
import IconThumbsDown from './icons/icons/IconThumbsDown.vue'
import { getFeedback } from '@/util/feedback-persistence'

export default {
  components: {
    IconThumbsUp,
    IconThumbsDown
  },
  props: {
    messageId: {
      type: [String, Number],
      default: null
    },
    interactive: {
      type: Boolean,
      default: true
    },
    storageType: {
      type: String,
      default: 'local'
    },
    sessionId: {
      type: String,
      default: null
    },
    onMessageFeedback: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      selected: null
    }
  },
  watch: {
    sessionId: {
      immediate: true,
      handler () {
        this.loadSelected()
      }
    },
    messageId () {
      this.loadSelected()
    }
  },
  methods: {
    loadSelected () {
      this.selected = getFeedback(this.storageType, this.sessionId, this.messageId)
    },
    onSelect (value) {
      if (!this.interactive) return
      if (this.selected === value) {
        this.selected = null
        this.onMessageFeedback(this.messageId, null)
        return
      }
      this.selected = value
      this.onMessageFeedback(this.messageId, value)
    }
  }
}
</script>
